module.exports = __webpack_public_path__ + "static/media/device.c6612a27.svg";